export const adminSettingsRoute = 'settings/admin';
export const editorRoute = 'editor/:documentId';

export const getEditorRoute = (id: string) => `/editor/${id}`;

export const devOpsEditorRoute = 'devops-editor/:projectId/*';
export const getDevOpsEditorRoute = (projectId: string, filePath: string) =>
    `/devops-editor/${projectId}/${encodeURIComponent(filePath)}`;
